import { getKeycloakAccessToken } from "../../../restService";
import Metrics from "./Metrics";
import RecentEntries from "./RecentEntries";
import RewardsDisbursement from "./RewardsDisbursement";

const Dashboard = () => {
  return (
    <div className="h-full px-4 md:px-8 w-full">
      <Metrics />
      <div className="md:grid md:grid-cols-2 flex flex-col h-full gap-5 mt-16">
        <div className="bg-white  p-3 shadow rounded col-span-1 overflow-auto">
          <RecentEntries />
        </div>
        <div className="col-span-1 p-3  bg-white shadow rounded">
          <RewardsDisbursement />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
